import React from 'react';
import Link from 'next/link';
import twMerge from 'utilities/src/twMerge';

interface Props {
  href: string;
  label: string;
  isActive: boolean;
  isDark?: boolean;
  index: number;
}

export default function LinkItem({ href, label, isActive, isDark, index }: Props) {
  return (
    <Link
      href={href}
      className={twMerge(
        'mdL:font-bold mdL:items-start flex h-full items-center',
        'hover:bg-site-neutrals-100 transition-[background-color] duration-300',
        {
          'text-site-neutrals-600 bg-site-neutrals-50 transition-colors': isActive,
          'text-site-neutrals-0 bg-site-neutrals-900': isDark && isActive,
          'hover:text-site-neutrals-0 hover:bg-site-neutrals-600': isDark,
        },
      )}
    >
      <span
        className={twMerge('mdL:mx-8 mdL:py-4 mx-4 w-full text-nowrap py-2', 'border-site-neutrals-50', {
          'mdS:border-none border-t': index !== 0,
          'border-site-neutrals-600': isDark,
        })}
      >
        {label}
        <span className={twMerge('text-site-primary-600', { invisible: !isActive })}>.</span>
      </span>
    </Link>
  );
}
